import React from 'react'

const PortfolioItem = (props) => {
	const renderTitle = (title, url) => {
		return ( title && url ) ? <a href={url}>{title}</a> : title;
	}
	const renderImage = () => {
		if (props.item.pictureSrc) {
			return (
				<div className="PortfolioItem__picture">
					<img className="PortfolioItem__picture-img" src={props.item.pictureSrc} alt="" />
				</div>
			)
		} else {
			return false;
		}
	}
	return (
		<div className="PortfolioItem Section -item">
			<div className="Section__content">
				<div className="PortfolioItem__title">
					<h1>						
						{ renderTitle( props.item.title, props.item.url ) }
					</h1>
				</div>
				<div className="PortfolioItem__position">
					{props.item.position}
				</div>
				<div className="PortfolioItem__desc" dangerouslySetInnerHTML={{__html: props.item.description}}>
				</div>
				{ renderImage() }
				<ul className="PortfolioItemTechList">
					{props.item.techs.map((el, index) => {
						return <li key={index} className="TechItem">{el}</li>
					})}
				</ul>
			</div>
		</div>
	)
}

export default PortfolioItem



// WEBPACK FOOTER //
// ./src/portfolioItem.js